export default class BaseComponent {
    childComponents = [];
    parentComponent = undefined;
    element;
    constructor(properties, ...children) {
        const { elementTag, text, classes, ...rest } = properties;
        this.element = document.createElement(elementTag);
        if (children.length > 0) {
            this.appendChildren(...children);
        }
        if (text) {
            this.setText(text);
        }
        if (classes && classes.length > 0) {
            this.addClasses(...classes);
        }
        Object.assign(this.element, rest);
    }
    appendChildren(...children) {
        for (const child of children)
            this.appendSingle(child);
        return this;
    }
    appendSingle(child) {
        this.element.append(child.getElement());
        this.childComponents.push(child);
        child.parentComponent = this;
        return this;
    }
    getElement() {
        return this.element;
    }
    removeSelf() {
        this.removeChildren();
        this.element.remove();
        if (this.parentComponent) {
            this.parentComponent.childComponents = this.parentComponent.childComponents.filter((child) => child !== this);
        }
    }
    removeChildren() {
        for (const child of this.childComponents)
            child.removeSelf();
        this.childComponents.length = 0;
        return this;
    }
    addClasses(...classes) {
        this.element.classList.add(...classes);
        return this;
    }
    removeClasses(...classes) {
        this.element.classList.remove(...classes);
        return this;
    }
    toggleClasses(...classes) {
        for (const className of classes) {
            this.element.classList.toggle(className);
        }
        return this;
    }
    setText(text) {
        this.element.textContent = text;
        return this;
    }
    addListener(eventType, handler, options) {
        this.element.addEventListener(eventType, handler, options);
        return this;
    }
    removeListener(eventType, handler) {
        this.element.removeEventListener(eventType, handler);
        return this;
    }
}
